import http from "./http.js";

async function getEmployee(id) {
  try {
    const response = await http.get(`employees/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      clientsAnalyst: response.data.clientsAnalyst.map(g => {
        return {
          id: g.id,
          title: g.title,
          editMode: false,
        };
      }),
      grades: response.data.grades.map(g => {
        return {
          startFrom: g.startFrom,
          value: g.value,
          project: g.project
            ? { id: g.project.id, title: g.project.title }
            : null,
          editMode: false,
        };
      }),
      email: response.data.email,
      department: response.data.department,
    };
  } catch (err) {
    throw err;
  }
}

async function updateEmployee(id, employee) {
  try {
    const response = await http.put(`employees/${id}`, employee);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getEmployees(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `employees?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectEmployee(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "employees/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function removeClientsAnalystFromEmployee(id) {
  try {
    const response = await http.patch(`clients/${id}/rpc/unassign-analyst`);
    return response;
  } catch (err) {
    throw (err);
  }
}

async function addEmployeeToClient(clientID, employeeID) {
  try {
    const response = await http.patch(`clients/${clientID}/rpc/assign-analyst/${employeeID}`);
    return response;
  } catch (err) {
    throw (err);
  }
}

export { getEmployee, updateEmployee, selectEmployee, getEmployees, removeClientsAnalystFromEmployee, addEmployeeToClient };
